import {
  Authority,
  BizsolState,
  ConnectBoardState,
  MeQuery,
} from "@/generated/graphql";
import { graphql, HttpResponse } from "msw";

export const meHandler = graphql.query<MeQuery>(
  "me",
  ({ query, variables }) => {
    return HttpResponse.json({
      data: {
        me: {
          sub: "sub1",
          username: "username1",
          authority: Authority.Admin,
          email: "username1@moneyforward.co.jp",
          lastName: "名字",
          lastNameKana: "ミョウジ",
          middleName: "ミドルネーム",
          middleNameKana: "ミドルネームカナ",
          firstName: "名前",
          firstNameKana: "ナマエカナ",
          companyName: "法人名",
          resignedTermsOfService: true,
          xCompanyID: "x-company-id",
          bizsolState: BizsolState.Waiting,
          connectBoardState: ConnectBoardState.Connected,
          createdAt: "2023-04-26T14:43:42.211172382+09:00",
          updatedAt: "2023-05-26T14:43:42.211172382+09:00",
        },
      },
    });
  }
);
